import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/event-details.jpg'


const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-7" }
const _hoisted_3 = { class: "col-lg-5" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-6" }
const _hoisted_6 = { class: "col-lg-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AnnualConference = _resolveComponent("AnnualConference")!
  const _component_EventInfo = _resolveComponent("EventInfo")!
  const _component_AboutThisEvent = _resolveComponent("AboutThisEvent")!
  const _component_SpeakerTopic = _resolveComponent("SpeakerTopic")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "mb-4" }, [
      _createElementVNode("img", {
        src: _imports_0,
        class: "rounded-3",
        alt: "event-details"
      })
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_AnnualConference)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_EventInfo)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_AboutThisEvent)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_SpeakerTopic)
      ])
    ])
  ]))
}